module.exports = __webpack_public_path__ + "img/avatar-holder.081eaed.png";